import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectAzienda} from "@commons/core.slice";
import AziendaNavContainer from "../../../features/azienda/AziendaNavContainer";
import {useQueryFilter, useSetIdAziendaTabelle} from "@components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";

import {CreateButton, useEditor} from "../../../core/editor";
import {Tab} from "@headlessui/react";
import DTTitle from "../../../components/dataTable/TableTitle";
import DTTable from "../../../components/dataTable/Table";
import Pagination from "../../../components/dataTable/Pagination";
import React from "react";
import {
    useDeleteElementoMutation,
    useGetAziendaQualificaQuery,
    useInsertElementoMutation,
    useLazyGetElementoQuery,
    useUpdateElementoMutation
} from "@commons/features/azienda/tabelle/aziendaQualifiche.api";
import {QualificaRecord} from "@commons/mapping/CentroDiCostoRecord";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {IdAziendaParams} from "@commons/utils/APIParams";
import * as Buttons from "../../../components/dataTable/buttons";

const QualifichePage: React.FC<{}> = () => {
    const azienda: AziendaRecord | null = useAppSelector(selectAzienda);

    const [getTrigger, result, promiseInfo] = useLazyGetElementoQuery();
    const [insertTrigger, insertResult] = useInsertElementoMutation();
    const [updateTrigger, updateResult] = useUpdateElementoMutation();
    const [deleteTrigger, deleteResult] = useDeleteElementoMutation();

    const {resource, create, cancel, URI, loadResource, saveResource, deleteResource} = useEditor<QualificaRecord>(insertTrigger, getTrigger, updateTrigger, deleteTrigger)

    const pagination = usePagination('',1, 10);
    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;

    const {filter, setFilter, skip} = useQueryFilter<IdAziendaParams>({} as IdAziendaParams, pagination);
    useSetIdAziendaTabelle(azienda, setFilter);
    const {data} = useGetAziendaQualificaQuery(filter, {skip: skip || !filter.idAzienda});
    const localData = data;

    return (<>
        <AziendaNavContainer>
            <div className="px-2 py-3 bg-gray-200 rounded-lg">
                <div className="m-2">
                    <div className="relative">
                        <div className="absolute right-2">
                            <CreateButton<QualificaRecord> create={create} label="QualificaRecord"/>
                        </div>
                    </div>
                    <Tab.Group>
                        <Tab.List className="tab-list">
                            <Tab className="tab">Propriet&agrave;</Tab>
                            {/*<Tab className="tab">Altro...</Tab>*/}
                        </Tab.List>
                        <Tab.Panels className="tab-panels">
                            <Tab.Panel>
                                {resource && <div className="p-3">
                                    {/*<QualificaEditor resource={resource} onSubmit={saveResource} onCancel={cancel}></QualificaEditor>*/}
                                </div>}
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </div>
            </div>

            <DTTitle id="elencoTabelle" title="Tabelle qualifiche azienda" {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch}}/>

            <DTTable<QualificaRecord> dtSchema={localData}
                                      header={<>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Codice
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Descrizione
                                    </th>
                                    <th scope="col" className="py-3.5 w-14"/>
                                </>}

                                      rows={({item, index, isMobile, currentRow, register}) => (
                                    <tr {...register(item.id!, index, item.URI === URI)}>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                            {item.id}
                                        </td>

                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                            {item.descrizione}
                                        </td>

                                        <td className="whitespace-nowrap py-2 text-sm font-medium">
                                            <Buttons.Visibility visible={isMobile || index === currentRow}>
                                                <Buttons.Edit onAction={() => loadResource(item.URI)}/>
                                                <Buttons.Delete onConfirm={() => {
                                                    deleteResource(item.URI!)
                                                }}/>
                                            </Buttons.Visibility>
                                        </td>
                                    </tr>)
                                }
            />

            <Pagination dataTables={localData} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination>


        </AziendaNavContainer>
    </>)
}
export default QualifichePage;